// eslint-disable-next-line
import ApiService from '../api.service';

const ProjectEvaluations = {
  index: params => ApiService.query('/api/v1/principals/me/project_evaluations', params),
  update: (evaluationId, params) => ApiService.put(`/api/v1/principals/me/project_evaluations/${evaluationId}`, params),
  hasPendingEvaluations: () => ApiService.get('/api/v1/principals/me/project_evaluations/has_pending_evaluations'),
};

export default ProjectEvaluations;
